import axios from 'axios';
import cookies from 'vue-cookies';
import router from './router';

// baseURL: `https://api.${window.location.host}`,
//  baseURL: process.env.VUE_APP_URL,

function getBaseUrl() {
  if (import.meta.env.MODE === 'development') {
    return import.meta.env.VITE_APP_URL;
  }

  return `https://api.${window.location.host}`;
}

const axiosApi = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    'Content-type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    Authorization: cookies.get('PublicToken'),
  },
  withCredentials: true,
});

const axiosFormDataApi = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    'Content-type': 'multipart/form-data',
    'Access-Control-Allow-Origin': '*',
    Authorization: cookies.get('PublicToken'),
  },
  withCredentials: true,
});

function returnMessageErrorTypeBlob(error) {
  return error.response.data.text().then((text) => {
    try {
      const json = JSON.parse(text);
      return Promise.reject(json.Message || error.message);
    } catch (e) {
      return Promise.reject(error.message);
    }
  });
}

/* Response Interceptors */
const interceptResponse = (res) => Promise.resolve(res.data);

const interceptResponseErrors = async (error) => {
  if (error.response.status === 400 || error.response.status === 406) {
    // Se data é um Blob (ex: responseType: 'blob'), fazer parse
    if (error.response.data instanceof Blob) {
      return returnMessageErrorTypeBlob(error);
    }
    return Promise.reject(error.response.data.Message || error.message);
  }
  if (error.response.status === 401) {
    cookies.remove('PublicToken', '/', '.vr.app.br');
    window.location.href = 'https://vr.app.br/';
  }
  if (error.response.status === 403) {
    router.push({ name: 'accessdenied', params: { msg: error.response.data.Message || error.message } });
  } else {
    router.push({ name: 'error', params: { msg: error.response.data instanceof Blob ? await returnMessageErrorTypeBlob(error) : error.response.data.Message || error.message } });
  }
  return error.response.data instanceof Blob ? returnMessageErrorTypeBlob(error) : Promise.reject(error);
};

axiosApi.interceptors.response.use(interceptResponse, interceptResponseErrors);
axiosFormDataApi.interceptors.response.use(interceptResponse, interceptResponseErrors);

/* Request Interceptors */
const interceptRequest = (request) => request;
const interceptRequestErrors = (err) => Promise.reject(err);

axiosApi.interceptors.request.use(interceptRequest, interceptRequestErrors);
axiosFormDataApi.interceptors.request.use(interceptRequest, interceptRequestErrors);

export { getBaseUrl, axiosFormDataApi };
export default axiosApi;
